import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseLozengeElement, toDateLozengeProps } from '../common';
var DueOnElement = function DueOnElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toDateLozengeProps(context.dueOn) : null;
  return data ? /*#__PURE__*/React.createElement(BaseLozengeElement, _extends({}, data, props, {
    name: ElementName.DueOn
  })) : null;
};
export default DueOnElement;